<h1 mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    Add a Sub Account
</h1>
<mat-dialog-content>
    <div class="container-fluid p-2">
        <div class="row" [formGroup]="subaccountForm">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Enter your client's email</mat-label>
                <mat-error>You need to enter a valid email</mat-error>
                <input matInput placeholder="example@example.com" formControlName="targetEmail" required>
                <mat-hint>Enter your client's email</mat-hint>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading" >Close</button>
    <button mat-raised-button class="w-25" color="primary" [disabled]="!subaccountForm.valid || isLoading" (click)="onSubmitForm()">
        <span *ngIf="!isLoading">Save</span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3"
            class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>